export default "__VITE_ASSET__a8088392__"